import React, { useCallback, useEffect, useState } from 'react';

interface CountdownTimerProps {
  startDate: string | Date;
  onTimeEnd: () => void;
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({ startDate, onTimeEnd }) => {
  const calculateTimeLeft = useCallback(() => {
    const difference = +new Date(startDate) - +new Date();
    let timeLeft = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  }, [startDate]);

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const [timeEnded, setTimeEnded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      const newTimeLeft = calculateTimeLeft();
      setTimeLeft(newTimeLeft);

      if (
        !timeEnded &&
        newTimeLeft.days === 0 &&
        newTimeLeft.hours === 0 &&
        newTimeLeft.minutes === 0 &&
        newTimeLeft.seconds === 0
      ) {
        onTimeEnd();
        setTimeEnded(true);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [timeLeft, timeEnded, startDate, onTimeEnd, calculateTimeLeft]);

  return (
    <div className="flex justify-center gap-5">
      <div className="flex flex-col items-center gap-2">
        <p className="text-2xl font-medium">{timeLeft.days}</p>
        <p className="text-sm font-normal">days</p>
      </div>
      <p className="text-2xl font-medium">:</p>
      <div className="flex flex-col items-center gap-2">
        <p className="text-2xl font-medium">{timeLeft.hours}</p>
        <p className="text-sm font-normal">hrs</p>
      </div>
      <p className="text-2xl font-medium">:</p>
      <div className="flex flex-col items-center gap-2">
        <p className="text-2xl font-medium">{timeLeft.minutes}</p>
        <p className="text-sm font-normal">mins</p>
      </div>
      <p className="text-2xl font-medium">:</p>
      <div className="flex flex-col items-center gap-2">
        <p className="text-2xl font-medium">{timeLeft.seconds}</p>
        <p className="text-sm font-normal">secs</p>
      </div>
    </div>
  );
};

export default CountdownTimer;
